import React, { useState } from "react";

import FullSpinner from "@student_components/Loader/FullSpinner";
import ButtonSpinner from "@student_components/Loader/ButtonSpinner";
import MediumSpinner from "@student_components/Loader/MediumSpinner";

// Шинэ Spinner
import Spinn from "@student_components/spinner/Spinn";
import MdSpinn from "@student_components/spinner/MedSpinn";
import SmSpinn from "@student_components/spinner/SmSpinn";



// Энгийн Spinner ашиглахдаа тухайн ашиглах гэж буй газрын parent div-дээ
// 'position-relative' className-ийг нэмж өгснөөр зөвхөн тэр хэсгийн арыг blur-дэж голд нь Loader ажиллана.

// Хэрэв ингэж зааж өгөхгүй бол Loader дэлгэцийг тэр чигт нь blur-дэх эрсдэлтэйг анхаарна уу.


/**
 * Loading ийг хүсэлт явуулж байх хооронд харуулах эсэхийг ашиглах
 * @param {boolean} isFullScreen    бүтэн дэлгэцээр харуулах эсэх
 * @param {boolean} isSmall         Товч болон text зэргийн өмнө унших жижиг loader авах эсэх
 * @param {boolean} initValue       Loader ийн анхны утга
 * @param {boolean} text            Loader ийн өмнө харагдах text
 * @param {boolean} hasBackground   background харуулах эсэх
 */

export default function useLoader({
	isFullScreen = false,
	isSmall = false,
	initValue = false,
	timeout = false,
	source = null,
	text=false,
}) {
	const [isLoading, setLoading] = useState(initValue);

	const fetchData = async (axios) => {
		setLoading(true);
		const rsp = await axios.catch((err) => {
			if (timeout) {
				setTimeout(() => {
					// setLoading(false);
				}, 1000);
			} else {
				setLoading(false);
			}
			return Promise.reject(err);
		});
		if (timeout) {
			setTimeout(() => {
				setLoading(false);
			}, 1000);
		} else {
			setLoading(false);
		}
		return rsp;
	};

	const cancel = () => {
		source && source.cancel("cancel");
	};

	return {
		Loader: isFullScreen
				?
				<Spinn/>
				:
				 isSmall
					? <SmSpinn />
					: <MdSpinn/>,
				fetchData, isLoading, cancel, setLoading
		};
}
